import React from "react";
import { Link } from "react-router-dom";

const SocialMediaLink = ({ linkImage, href }) => {
  return (
    <Link
      className="w-10 h-10 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-skyBlue"
      to={href}
    >
      {linkImage}
    </Link>
  );
};

export default SocialMediaLink;
